import { Skeleton } from "@/components/ui/skeleton";

export function SearchResultSkeleton() {
  return (
    <div className="flex items-center gap-2 px-3 py-2">
      <Skeleton className="size-3.5 shrink-0" />
      <Skeleton className="h-3.5 w-48" />
    </div>
  );
}
